import React from 'react';
import styles from './Switch.module.css';

export default function Switch({ id, name, label, checked, onChange, disabled }) {
  return (
    <label className={styles.wrapper} htmlFor={id}>
      <span className={styles.track}>
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span className={styles.slider} />
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
}
